<template>
  <div class="system">
    <div class="top">
      <img :src="$apiBaseUrl+top" style="width: 100%;height: 450px">
    </div>
    <div class="con_data">
      <div class="sys">
        <h1 class="center blue">系统解决方案</h1>
        <div class="center">系统解决成功案例展示</div>
      </div>
      <div class="plate" v-for="(item,index) in imgData" :key="index">
        <router-link :to="{path:'/sysDetails',query:{Id:item.Id}}"><img :src="$apiBaseUrl+item.NewsImg" width="360" height="200"></router-link>
        <h4 class="center mar0">{{item.NewsTitle}}</h4>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "system",
  data(){
    return{
      top:'',
      imgData:[],
    }
  },
  mounted() {
    this.getTop();
    this.getImg()
  },
  methods:{
    //获取banner
    getTop(){
      let data={params:{ImgCate:7}}
      this.$axios.get('/api/Byt_Ent_Gateway/BytEntImgSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.top = res.data[0].ImgPath;
      })
    },
    //获取图片
    getImg(){
      let data={params:{NewsCate:1}}
      this.$axios.get('/api/Byt_Ent_Gateway/BytEntNewsSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.imgData = res.data;
      })
    },

  }
}
</script>

<style scoped>
.bus_con{
  clear: left;
  width: 1200px;
  overflow: hidden;
}
.plate{
  width:360px;
  padding: 20px;
  float: left;
}
.plate a{
  display: block;
  width: 360px;
  height: 200px;
  border: solid 1px #ddd;
  overflow: hidden;
  transition:5s;
}
.plate a:hover>img{
  transform: scale(1.2);
}
</style>